import dayjs from 'dayjs';
import { formatNumber, getTimeUnitHebrew, monthsMap } from 'src/viewsUtils';
import { TimeSpan } from '../store/dashboardViewSlice/types';
import { ShekelSign } from 'src/viewsTypes';

export const getFormattedXTick = (value: any, index: number) => {
  const year = dayjs().format('YY');
  return `'${year} ${monthsMap[value]}`;
};
export const getFormattedYTick = (value: any, index: number) => {
  if (typeof value !== 'number') return value;
  const formattedValue = formatNumber(value);

  return `${formattedValue}${ShekelSign}`;
};
export const getFormattedTimeSpanTitle = (
  timeSpan: TimeSpan,
  suffix?: string | null,
) => {
  const { count, timeUnit } = timeSpan;

  const timeUnitHebrew = getTimeUnitHebrew(timeUnit, count);
  const timeUnitSuffix = (() => {
    if (suffix) return suffix;
    if (suffix === null) return '';
    if (count === 1) {
      switch (timeUnitHebrew) {
        case 'שעה':
        case 'דקה':
        case 'שניה':
        case 'מילישניה':
          return 'אחרונה'; // Feminine singular

        case 'שנה':
          return 'אחרונה'; // Special case for "year" which is feminine

        default:
          return 'אחרון'; // Masculine singular for other units
      }
    } else {
      switch (timeUnitHebrew) {
        case 'ימים':
        case 'חודשים':
          return 'אחרונים'; // Masculine plural

        case 'שנים':
        case 'שעות':
        case 'דקות':
        case 'שניות':
        case 'מילישניות':
          return 'אחרונות'; // Feminine plural
      }
    }
  })();
  return `${count} ${timeUnitHebrew} ${timeUnitSuffix}`.trim();
};
export const calculateEvenTicks = (
  maxYValue: number,
  numberOfTicks: number = 4,
): number[] => {
  // Create an array of tick values based on fractions of the maximum value
  const ticks = Array.from({ length: numberOfTicks }, (_, i) => {
    return i === numberOfTicks - 1
      ? maxYValue
      : Math.trunc((i * maxYValue) / (numberOfTicks - 1));
  });

  return ticks;
};
